import React, { useState, useEffect, useRef } from "react";
import "../../../../../../../css/workspace.css";
import $ from "jquery";
import * as types from "../../../../../../../redux/constants/collectionConstants";
import { connect, useSelector, useDispatch} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Button,
  Avatar,
  Card,
  Popover,
} from "antd";
import {
  FileTextOutlined,
  LinkOutlined,
  InfoCircleOutlined,
  FontSizeOutlined
} from "@ant-design/icons";
import AddLocalFile from './addLocalFile';
import AddURL from './addURL';
import AddText from './addText';

const UploadDocuments = () => {

  const { Meta } = Card;
  const dispatch = useDispatch();
  
  const [uploadMode, setUploadMode] = useState("file");
  const [docsList, setDocsList] = useState([]);

  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  let planType;
  if (groupPlan?.planId == 4) {
    planType = "team";
  } else if (groupPlan?.planId == 5) {
    planType = "business";
  } else {
    planType = "pro";
  }

  const documentsList = useSelector((state) => state.collectionReducer.collectionDocs);

  const collectionSource = useSelector(
    (state) => state.collectionReducer.collectionSource
  );

  const userDetails = useSelector(
    (state) => state?.organizationReducer?.currentOrganization
  );
  const viewOnly = userDetails?.role_id === "1" ? true : false;

  useEffect(() => {
    setDocsList(documentsList)
  },[documentsList]);

  useEffect(() => {
    if(docsList?.length > 0){
    dispatch({
        type: types.UPDATE_COLLECTION_DOCS_LIST,
        collectionDocs: docsList,
      });
    }
  }, [docsList]);

  const uploadContent = (
    <div className="wk-popcontent">
      <p>
        Upload the document and start asking questions! Configure the AI Coach
        with your team's or organization's knowledge by simply adding
        collections of documents. Once uploaded, AI Coach can help you discover
        information from the collection of data.
      </p>
      <p>
        Valid file types: *.pptx, *.docx, *.xlsx, *.pdf,
        *.pptx, *.mp3, *.mp4, *.wav, *.m4a, *.mpeg, *.flac, *.eml, *.msg
      </p>
      <p>Please ensure your files meet the following requirements:</p>
      <p>Documents (PDF, PPTX, DOCX): Max size 64MB</p>
      <p>Audio/Video Files: Max size 24MB</p>
      <p>Spreadsheets (XLSX): Max size 10MB</p>
    </div>
  );
  const addContent = (
    <div className="wk-popcontent">
      <p>
        Add data from public URLs and start asking questions! Configure the AI
        Coach with your team's or organization's knowledge by simply adding
        collections of public URLs. Once added, AI Coach can help you discover
        information from the collection of data. Only public URLs are allowed.
      </p>
    </div>
  );
  const textContent = (
    <div className="wk-popcontent">
      <p>
        Add data from public URLs and start asking questions! Configure the AI
        Coach with your team's or organization's knowledge by simply adding
        collections of public URLs. Once added, AI Coach can help you discover
        information from the collection of data. Only public URLs are allowed.
      </p>
    </div>
  );

  return (
      <>
        <div className="wk-upload-flex">
          <Card onClick={(e) => {
              setUploadMode("file");
          }}
          className={`${uploadMode === "file" ? "active" : ""} ${collectionSource === "database" || viewOnly ? "disabled" : ""}`}
          style={{ pointerEvents: collectionSource === "database" || viewOnly ? "none" : "auto" }}>
            <Popover content={uploadContent}>
              <Button
                className="wk-upload-info"
                type="link"
                icon={<InfoCircleOutlined />}
              ></Button>
            </Popover>
            <Meta
              avatar={
                <Avatar
                  icon={<FileTextOutlined />}
                  style={{ backgroundColor: "#1d262e" }}
                />
              }
              title="Add documents"
              // description="Upload the document and start asking questions!"
            />
          </Card>
          <Card onClick={(e) => {
              setUploadMode("url");
          }}
          className={`${uploadMode === "url" ? "active" : ""} ${collectionSource === "database" || viewOnly ? "disabled" : ""}`}
          style={{ pointerEvents: collectionSource === "database" || viewOnly ? "none" : "auto" }}
            >
            <Popover content={addContent}>
              <Button
                className="wk-upload-info"
                type="link"
                icon={<InfoCircleOutlined />}
              ></Button>
            </Popover>
            <Meta
              avatar={
                <Avatar
                  icon={<LinkOutlined />}
                  style={{ backgroundColor: "#1d262e" }}
                />
              }
              title="Add URL"
              // description="Add data from public URLs and start asking questions! "
            />
          </Card>
          <Card onClick={(e) => {
              setUploadMode("text");
          }}
          className={`${uploadMode === "text" ? "active" : ""} ${collectionSource === "database" || viewOnly ? "disabled" : ""}`}
          style={{ pointerEvents: collectionSource === "database" || viewOnly ? "none" : "auto" }}
            >
            <Popover content={textContent}>
              <Button
                className="wk-upload-info"
                type="link"
                icon={<InfoCircleOutlined />}
              ></Button>
            </Popover>
            <Meta
              avatar={
                <Avatar
                  icon={<FontSizeOutlined />}
                  style={{ backgroundColor: "#1d262e" }}
                />
              }
              title="Add Text"
              // description="Add text from public URLs and start asking questions! "
            />
          </Card>
        </div>
        
        <div className="wk-upload">          
          {uploadMode == "file" ? (
              <AddLocalFile/>
            ) : null}
          {uploadMode == "url" ? (
              <AddURL/>
            ) : null}
          {uploadMode == "text" ? (
              <AddText/>
            ) : null}
        </div>
      </> 
    );
}

export default UploadDocuments;